<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Estadísticas de Atención a Citas</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div id="formulario">
              <div class="row">
                <div class="col-1"><b>Juzgado:</b></div>
                <div class="col-3">
                  <C001Areas v-on:valorParaElPadre="cambioArea"
                             :prefijo="enumeraciones.etiquetasDeHTML.Select"
                             :tipo="enumeraciones.tiposDeSelect.Todos"
                             :idDelInput="'catalogoArea'"
                             :parametros="parametros_Area"
                             :valorDefinido="parametros_Area.ValorDefinido">
                  </C001Areas>
                </div>
                <div class="col-1"><b>Fecha Inicial:</b></div>
                <div class="col-3"><input type="date" class="form-control" v-model="FechaInicial" /></div>
                <div class="col-1"><b>Fecha Final:</b></div>
                <div class="col-3"><input type="date" class="form-control" v-model="FechaFinal" /></div>
              </div>
              <div class="row">
                <div class="col-10"></div>
                <div class="col-2"><input type="button" class="form-control" value="Buscar" @click="ObtenerEstadisticasAtencionCitas" /></div>
              </div>
            </div>
            <div id="tabla">
              <div class="row">
                <table class="table table-striped table-light table-hover" id="tablaEstadisticas">
                  <thead class="thead-dark">
                    <tr class="visible-element">
                      <th colspan="3">Citas Atendidas</th>
                      <th colspan="2">Citas No Atendidas</th>
                      <th>Trámites Sin Cita</th>

                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr>
                      <td colspan="3">{{CitasAtendidas}} - {{PorcentajeCitasAtendidas}}%</td>
                      <td colspan="2">{{CitasNoAtendidas}} - {{PorcentajeCitasNoAtendidas}}%</td>                      
                      <td>{{TramitesSinCita}}</td>
                    </tr>
                    <tr>
                      <td><span>Citas Concluidas: </span>{{CitasConcluidas}} - {{PorcentajeCitasConcluidas}}%</td>
                      <td><span>Citas Canceladas(Solicitante): </span>{{CitasCanceladasSolicitante}} - {{PorcentajeCitasCanceladasSolicitante}}%</td>
                      <td><span>Citas Sin Asistencia: </span>{{CitasSinAsistencia}} - {{PorcentajeCitasSinAsistencia}}%</td>
                      <td><span>Citas Canceladas(Recepción): </span>{{CitasCanceladasRecepcion}} - {{PorcentajeCitasCanceladasRecepcion}}%</td>
                      <td><span>Citas No Atendidas: </span>{{CitasRezagadas}} - {{PorcentajeCitasRezagadas}}%</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row">
                <table class="table table-striped table-light table-hover" id="tablaEstadisticasExpedientes">
                  <thead class="thead-dark">
                    <tr class="visible-element">
                      <th>Expedientes Prestados</th>
                      <th>Expedientes No Disponibles</th>

                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr>
                      <td>{{ExpedientesPrestados}} - {{PorcentajeExpedientesPrestados}}%</td>
                      <td>{{ExpedientesNoPrestados}} - {{PorcentajeExpedientesNoPrestados}}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        parametros_Area: {
          ValorDefinido: 0,
          AreaId: null
        },
        Citas : 0,
        CitasAtendidas : 0,
        PorcentajeCitasAtendidas : 0,
        CitasNoAtendidas : 0,       
        PorcentajeCitasNoAtendidas : 0,       
        CitasCanceladasSolicitante : 0,
        PorcentajeCitasCanceladasSolicitante : 0,
        CitasConcluidas : 0,
        PorcentajeCitasConcluidas : 0,
        CitasCanceladasRecepcion : 0,
        PorcentajeCitasCanceladasRecepcion : 0,
        CitasSinAsistencia : 0,
        PorcentajeCitasSinAsistencia : 0,
        CitasRezagadas : 0,
        PorcentajeCitasRezagadas : 0,        
        TramitesSinCita : 0,
        ExpedientesPrestados : 0,
        ExpedientesNoPrestados : 0,
        FechaInicial: null,
        FechaFinal: null
      }
    },
    components: {
      C001Areas: catalogos.SICCIJ.C001Areas
    },
    methods: {
      ObtenerEstadisticasAtencionCitas: function () { //Retorna las estadísticas en base a los filtros capturados.
        var peticion = {
          "esPrueba": false,
          "AreaId": this.parametros_Area.AreaId,
          "FechaInicial": this.FechaInicial,
          "FechaFinal": this.FechaFinal
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.ObtenerEstadisticasAtencionCitas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response)
            this.Citas = response.data.NumeroCitas           
            this.CitasCanceladasSolicitante = response.data.NumeroCitasCanceladasSolicitante
            this.CitasConcluidas = response.data.NumeroCitasConcluidas
            this.CitasCanceladasRecepcion = response.data.NumeroCitasCanceladasRecepcion
            this.CitasSinAsistencia = response.data.NumeroCitasSinAsistencia
            this.CitasRezagadas = response.data.NumeroCitasRezagadas            
            this.TramitesSinCita = response.data.NumeroTramitesSinCita
            this.ExpedientesPrestados = response.data.NumeroExpedientesPrestados
            this.ExpedientesNoPrestados = response.data.NumeroExpedientesNoPrestados
            this.CitasAtendidas = this.CitasConcluidas + this.CitasCanceladasSolicitante + this.CitasSinAsistencia;
            this.CitasNoAtendidas = this.CitasCanceladasRecepcion + this.CitasRezagadas;
            this.PorcentajeCitasCanceladasSolicitante = (this.CitasCanceladasSolicitante / this.CitasAtendidas * 100).toFixed(2)
            this.PorcentajeCitasConcluidas = (this.CitasConcluidas / this.CitasAtendidas * 100).toFixed(2)
            this.PorcentajeCitasCanceladasRecepcion = (this.CitasCanceladasRecepcion / this.CitasNoAtendidas * 100).toFixed(2)
            this.PorcentajeCitasSinAsistencia = (this.CitasSinAsistencia / this.CitasAtendidas * 100).toFixed(2)
            this.PorcentajeCitasRezagadas = (this.CitasRezagadas / this.CitasNoAtendidas * 100).toFixed(2)
            this.PorcentajeCitasAtendidas = (this.CitasAtendidas / this.Citas * 100).toFixed(2)
            this.PorcentajeCitasNoAtendidas = (this.CitasNoAtendidas / this.Citas * 100).toFixed(2)
            this.PorcentajeExpedientesPrestados = (this.ExpedientesPrestados / (this.ExpedientesPrestados + this.ExpedientesNoPrestados) * 100).toFixed(2)
            this.PorcentajeExpedientesNoPrestados = (this.ExpedientesNoPrestados / (this.ExpedientesPrestados + this.ExpedientesNoPrestados) * 100).toFixed(2)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      cambioArea(datos) { //Administra los cambios en el componente de Área
        catalogos
        //console.log(datos);
        this.parametros_Area.AreaId = parseInt(datos[0].target.value);
      },
      fijarFechasDefault: function () { //Fija los input de fecha inicial y fecha final como el primer y último dia del mes en curso respectivamente.
        var date = new Date();
        this.FechaInicial = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
        this.FechaFinal = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
      }
    }, mounted: function mounted() {
      this.fijarFechasDefault();
      this.ObtenerEstadisticasAtencionCitas();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  #tabla {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Estadisticas/AtencionCitas/AtencionCitas.vue